/* eslint-disable @typescript-eslint/no-magic-numbers */
export const SVG_ICON_CACHE_SSR_CONTAINER_ID = 'svg-icon-cache-library-ssr';
export const SVG_ICON_CACHE_LIBRARY_ENTRY_EXPIRE_TIME_IN_MS = 1000 * 5;
